import createIcon from '../../createIcon';

/**
 * @component @name Toll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgNEMxMC41OCA0IDcgNy41OCA3IDEyQzcgMTYuNDIgMTAuNTggMjAgMTUgMjBDMTkuNDIgMjAgMjMgMTYuNDIgMjMgMTJDMjMgNy41OCAxOS40MiA0IDE1IDRaTTE1IDE4QzExLjY5IDE4IDkgMTUuMzEgOSAxMkM5IDguNjkgMTEuNjkgNiAxNSA2QzE4LjMxIDYgMjEgOC42OSAyMSAxMkMyMSAxNS4zMSAxOC4zMSAxOCAxNSAxOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0zIDEyQzMgOS4zOSA0LjY3IDcuMTcgNyA2LjM1VjQuMjZDMy41NSA1LjE1IDEgOC4yNyAxIDEyQzEgMTUuNzMgMy41NSAxOC44NSA3IDE5Ljc0VjE3LjY1QzQuNjcgMTYuODMgMyAxNC42MSAzIDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Toll = createIcon('Toll', [
  [
    'path',
    {
      d: 'M15 4C10.58 4 7 7.58 7 12C7 16.42 10.58 20 15 20C19.42 20 23 16.42 23 12C23 7.58 19.42 4 15 4ZM15 18C11.69 18 9 15.31 9 12C9 8.69 11.69 6 15 6C18.31 6 21 8.69 21 12C21 15.31 18.31 18 15 18Z',
      key: 'p3wom4',
    },
  ],
  [
    'path',
    {
      d: 'M3 12C3 9.39 4.67 7.17 7 6.35V4.26C3.55 5.15 1 8.27 1 12C1 15.73 3.55 18.85 7 19.74V17.65C4.67 16.83 3 14.61 3 12Z',
      key: 'ny9y5n',
    },
  ],
]);

export default Toll;
